import { gql } from '@apollo/client'

export const Demande = {} as any

Demande.fragments = {
  demande: gql`
    fragment Demande on d4_fn_view_demande {
      id
      numero
      description
      couleuretatkanban
      dateevenement
      maxmontant
      minmontant
      etatdemande
      dateconstat
      epingle
      batimentid
      batimentlibelle
      equipementid
      equipementlibelle
      typeequipementid
      typeequipementlibelle
      kanbanid
      kanbantitre
      etatkanbanid
      etatkanbanlibelle
      etatKanbanNumeroOrdre
      emetteurid
      emetteurnom
      emetteurprenom
      emetteurmail
      emetteurtel
      coproprieteid
      datecloturedefinitive
      datecloturepard4
      assuranceid
      urgence
      typedemande
      dtype
      suivics
      dossierpermanent
      copropriete {
        id
        trigramme
        nom
        gestionnaire {
          mail1
        }
        gestionnaireSedentaire {
          mail1
        }
        personnes(where: { dtype: { _eq: "Concierge" } }) {
          id
          nom
          prenom
          telfixe
          telportable
        }
        adresse {
          codepostal
          ville
          complementadresse
          voie
          typedevoie
          numerodanslavoie
        }
      }
      emetteur {
        id
        nom
        prenom
        societes {
          id
          raisonsociale
        }
      }
      actions_aggregate(where: { daterealisation: { _is_null: true } }) {
        aggregate {
          count
        }
      }
    }
  `,
  evenement: gql`
    fragment Evenement on d4_fn_view_evenements {
      id
      texte
      auteurnom
      auteurprenom
      auteurid
      auteurtype
      dateevenement
      dateinterventionrealisee
      datepriseencomptefournisseur
      interventionid
      interventionobjet
      interventionreference
      interventionfournisseur
      demandedevisfournisseurid
      demandedevisid
      demandedevisobjet
      fichier
      interventionobjet
      texte
      dtype
    }
  `,
}
